import { axiosV1 } from 'interceptors/axios';
import types from 'redux/actions/actionTypes';
import { decryptResponse } from 'utils/token';

import { dispatchError } from 'utils/dispatchError';
import { ApiQueryParams, CoOwner } from 'types';
import { Dispatch } from 'redux';

type CreateCoOwnerProps = {
  coOwnerData: Partial<CoOwner>;
};

type GetCoOwnersProps = {
  encumbranceId: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

type CoOwnersApiGetAllResponse = {
  data: CoOwner[];
  total: number;
};

export type CoOwnerMutationResponse = {
  coOwner: CoOwner | null;
};

type UpdateCoOwnerProps = {
  coOwnerId: string;
  updateCoOwnerData: Partial<CoOwner>;
};

type DeleteCoOwnerProps = {
  coOwnerId: string;
};

export const createCoOwner =
  ({ coOwnerData }: CreateCoOwnerProps) =>
  async (dispatch: Dispatch) => {
    const { data } = await axiosV1.post(`/co-owners`, coOwnerData);

    const decodedData = (await decryptResponse(
      data
    )) as CoOwnerMutationResponse;

    if (decodedData.coOwner) {
      dispatch({
        type: types.CREATE_COOWNER,
        coOwner: decodedData.coOwner,
      });
    }
    return decodedData.coOwner;
  };

export const getCoOwners =
  ({ encumbranceId, params = {}, signal }: GetCoOwnersProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.get('/co-owners', {
        params: {
          encumbranceId,
          ...params,
        },
        // signal,
      });

      const decodedData = (await decryptResponse(
        data
      )) as CoOwnersApiGetAllResponse;

      dispatch({
        type: types.GET_COOWNERS,
        coOwners: decodedData.data,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const updateCoOwner =
  ({ coOwnerId, updateCoOwnerData }: UpdateCoOwnerProps) =>
  async (dispatch: Dispatch) => {
    const body = { ...updateCoOwnerData };

    const { data } = await axiosV1.put(`/co-owners/${coOwnerId}`, body);
    const decodedData = (await decryptResponse(
      data
    )) as CoOwnerMutationResponse;

    dispatch({
      type: types.UPDATE_COOWNER,
      coOwner: decodedData?.coOwner,
    });
  };

export const deleteCoOwner =
  ({ coOwnerId }: DeleteCoOwnerProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.delete(`/co-owners/${coOwnerId}`);
      const decodedData = await decryptResponse(data);

      dispatch({
        type: types.DELETE_COOWNER,
        coOwnerId,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
